import "animate.css";
import "flatpickr/dist/flatpickr.css";
// import "simplebar-vue/dist/simplebar-vue.js";
// import "simplebar-vue/dist/simplebar.min.css";
// import "simplebar/dist/simplebar.min.css";
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';
import "sweetalert2/dist/sweetalert2.min.css";
import { createApp } from "vue";
import VueFlatPickr from "vue-flatpickr-component";
import VueGoodTablePlugin from "vue-good-table-next";
import "vue-good-table-next/dist/vue-good-table-next.css";
import VueSweetalert2 from "vue-sweetalert2";
import VueTippy from "vue-tippy";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueApexCharts from "vue3-apexcharts";
import VueClickAway from "vue3-click-away";
import App from "./App.vue";
import "./assets/scss/auth.scss";
import "./assets/scss/tailwind.scss";
import router from "./router";
import store from "./store";
import VCalendar from "v-calendar";
import "v-calendar/dist/style.css";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

// Configurer l'intercepteur axios pour gérer automatiquement le token
import "./plugins/axios";

// Main JS (in CommonJS format)
import VueTimepicker from "vue3-timepicker";
// CSS
import "vue3-timepicker/dist/VueTimepicker.css";

// check localStorage theme for dark light bordered
if (localStorage.theme === "dark") {
  document.body.classList.remove("light");
  document.body.classList.add("dark");
  store.state.theme = "dark";
  store.state.isDark = true;
} else {
  document.body.classList.remove("dark");
  document.body.classList.add("light");
  store.state.theme = "light";
  store.state.isDark = false;
}

if (localStorage.semiDark === "true") {
  document.body.classList.add("semi-dark");
  store.state.semidark = true;
  store.state.semiDarkTheme = "semi-dark";
} else {
  document.body.classList.add("semi-light");
  store.state.semidark = false;
  store.state.semiDarkTheme = "semi-light";
}

// check local storage for menuLayout
if (localStorage.menuLayout === "horizontal") {
  store.state.menuLayout = "horizontal";
} else {
  store.state.menuLayout = "vertical";
}

// check skin  for localstorage
if (localStorage.skin === "bordered") {
  store.state.skin = "bordered";
  document.body.classList.add("skin--bordered");
} else {
  store.state.skin = "default";
  document.body.classList.add("skin--default");
}

if (localStorage.currentUser != "" && localStorage.currentUser != undefined) {
  store.state.currentUser = JSON.parse(localStorage.currentUser);
} else {
  store.state.currentUser = {};
}

// check localStorage for token info
if (localStorage.token_expires_in != "" && localStorage.token_expires_in != undefined) {
  store.state.token_expires_in = parseInt(localStorage.token_expires_in);
}
if (localStorage.token_refresh_expires_in != "" && localStorage.token_refresh_expires_in != undefined) {
  store.state.token_refresh_expires_in = parseInt(localStorage.token_refresh_expires_in);
}
if (localStorage.loginTime != "" && localStorage.loginTime != undefined) {
  store.state.loginTime = parseInt(localStorage.loginTime);
}
if (localStorage.tokenRefreshTime != "" && localStorage.tokenRefreshTime != undefined) {
  store.state.tokenRefreshTime = parseInt(localStorage.tokenRefreshTime);
}

// vue use
createApp(App)
  .use(store)
  .use(VueSweetalert2)
  .use(Toast, {
    toastClassName: "dashcode-toast",
    bodyClassName: "dashcode-toast-body",
  })
  .use(router)
  .use(VueClickAway)
  .use(VueTippy, {
    defaultProps: {
      zIndex: 999999
    }
  })
  .use(VueFlatPickr)
  .use(VueGoodTablePlugin)
  .use(VueApexCharts)
  .use(VCalendar)
  .component('VueDatePicker', VueDatePicker)
  .component('VueTimepicker', VueTimepicker)
  .component('simplebar', simplebar)
  .mount("#app");
